import React, { useState, useEffect } from "react";
import axios from "axios";

// Components
import Preloader from "../../../components/Preloader/Preloader";

import MUIDataTable from "mui-datatables";

//Date Range
import { addDays, format } from "date-fns";
import { DateRangePicker } from "materialui-daterange-picker";
import numeral from "numeral";
// Material UI Component
import {
  FormGroup,
  FormLabel,
  FormControl,
  // ListItemText,
  TextField,
  // Checkbox,
  // FormControlLabel,
  Grid,
  Select,
  InputLabel,
  Input,
  // MenuItem,
  Modal,
  Backdrop,
  Fade,
  FormHelperText,
  NativeSelect,
  Button,
} from "@material-ui/core";
import {
  makeStyles,
  createMuiTheme,
  MuiThemeProvider,
} from "@material-ui/core/styles";
// Material Icons
import { AssessmentTwoTone, BorderBottom } from "@material-ui/icons";

import { NavLink } from "react-router-dom";
//Material UI Icons
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
//cookies
import { get_cookies, isLoggedIn } from "../../../components/Cookies/Cookies";

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },

  // paper: {
  // 	backgroundColor: theme.palette.background.paper,
  // 	border: "2px solid #000",
  // 	boxShadow: theme.shadows[5],
  // 	padding: theme.spacing(2, 4, 3),
  // },
}));

const tableStyle = {
  display: "grid",
  gridTemplateColumns: "1fr 1fr", // Two columns of equal width
  width: "100%",
  marginTop: 10,
  marginBottom: 10,
  border: "0.5px solid gray",
  backgroundColor: "#f1f1f1",
};

const cellStyle = {
  backgroundColor: "white",
  border: "0.5px solid gray",
  padding: "10px",
  textAlign: "center",
};

const getMuiTheme = () =>
  createMuiTheme({
    overrides: {
      MUIDataTableHeadCell: {
        root: {
          "&:nth-child(1)": {
            width: 150,
          },
          "&:nth-child(2)": {
            width: 180,
          },
          "&:nth-child(3)": {
            width: 700,
          },
        },
      },
    },
  });

const CashierTurnOver = () => {
  const [posts, setPosts] = useState([]);
  const [drSalesItem, setDrSalesItem] = useState([]);
  const [drTotal, setDrTotal] = useState(0.0);
  const [pkgTotal, setPackageTotal] = useState(0.0);
  const [dataLoaded, setDataLoaded] = useState(false);
  const [turnoverdate,setTurnoverDate] = useState("");
  const [turnoverDirect,setTurnoverDirect] = useState("");
  const [packageDirect,setPackageDirect] = useState("");
  const [open, setOpen] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [downloadFlag, setDownloadFlag] = useState(false);
  const [dateRange, setDateRange] = useState({
    startDate: new Date(),
    endDate: addDays(new Date(), 7),
  });
  const classes = useStyles();

  const [userName, setuserName] = useState(get_cookies("username")); //jc_username
  const [useridNo, setuseridNo] = useState(get_cookies("branchidno"));

  // Data Fetching
  useEffect(() => {
    data();
  }, []);

  useEffect(() => {
    if (posts.length > 0) {
      setDownloadFlag(true);
    } else {
      setDownloadFlag(false);
    }
  }, [posts]);

  const x = 0;
  useEffect(() => {
    console.log('2',dateRange.startDate);
    isLoggedIn();
  }, [x]);
  //search button
  const dataFilter = async () => {

		setDataLoaded(false);
		const result = await axios.get(
		  process.env.REACT_APP_API_URL + "cashier_turn_over_report",
		  {
		    params: {
		      date_from: format(dateRange.startDate, "yyyy/MM/dd/"), //format(dateRange.startDate, "yyyy/MM/dd/")
		      date_to: format(dateRange.endDate, "yyyy/MM/dd/"), //format(dateRange.endDate, "yyyy/MM/dd/")
		      jc_username: userName,
		      jc_user_id_no: useridNo,
		    },
		  }
		);
		console.log('asd',result);
		if(result.data.packagesalesDetails.length > 0){
			setPosts(result.data.packagesalesDetails);
			setPackageTotal(result.data.packageTotal);
			setPackageDirect(result.data.packagesalesTotal[0].totalamt);
		}else{
			setPosts([]);
			setPackageTotal(0.00);
			setPackageDirect(0.00);
		}
		if(result.data.directSales.length > 0){
			setDrSalesItem(result.data.directSales);
		setDrTotal(result.data.drTotal);
		setTurnoverDirect(result.data.directSalesTotal[0].totalamt);
		}else{
			setDrSalesItem([]);
		setDrTotal(0.00);
		setTurnoverDirect(0.00);	
		}
	
	
	
		setTurnoverDate(result.data.turnoverdate);
		setDataLoaded(true);
	
   
  };

  const data = async () => {
    setDataLoaded(true);
  };

  const toggle = () => setOpen(!open);

  const handleModalOpen = () => {
    setModalOpen(true);
  };

  const handleModalClose = () => {
    setModalOpen(false);
  };

  const dateRangeHandler = (range) => {
    setDateRange(range);
    setOpen(false);
  };
  const columns = [
    {
      name: "paymentid",
      label: "Type",
      options: {
        //filter: false,
        // display: "excluded",
      },
    },
    {
      name: "amount",
      label: "Total Amount",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <div style={{ textAlign: "right" }}>
              {numeral(value).format("0,0.00")}
            </div>
            // <div>{numeral(value).format('0,0.00')}</div>
          );
        },
      },
    },
    {
      name: " ",
      label: " ",
    },
  ];
  const columns1 = [
    {
      name: "paymentid",
      label: "paymentid",
      options: {
        //filter: false,
        // display: "excluded",
      },
    },
    {
      name: "totalamt",
      label: "Total Amount",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <div style={{ textAlign: "right" }}>
              {numeral(value).format("0,0.00")}
            </div>
            // <div>{numeral(value).format('0,0.00')}</div>
          );
        },
      },
    },
    {
      name: " ",
      label: " ",
    },
  ];

  const options = {
    filter: false,
    search: false,
    // filterType: "dropdown",
    selectableRows: "none",
    filterType: "multiselect",
    responsive: "standard",
    setFilterChipProps: (colIndex, colName, data) => {
      //console.log(colIndex, colName, data);
      return {
        color: "primary",
        variant: "outlined",
        className: "testClass123",
      };
    },
    download: false, //add this
    print: false,
    viewColumns: false, //add this
    downloadOptions: {
      filename: "CashierTurnoverReport.csv", //change filename of csv
    },
    // tableBodyHeight,
  };

  const style = {
    marginBottom: "1rem",
    marginTop: "2.5em",
  };

  return (
    <div className="page">
      <div className="page-header">
        <div className="page-icon">
          <AssessmentTwoTone />
        </div>
        <NavLink to={"/reports"}>
          <h4 style={{ color: "#1D1C1A" }}>Reports</h4>
        </NavLink>
        <ArrowForwardIosIcon
          style={{ paddingLeft: "10px", paddingRight: "10px" }}
        />
        <h4>Cashier Turnover Report</h4>
      </div>
      <div className="page-container">
        <div style={style}>
          <Grid container spacing={1}>
            <Grid item xs={12} sm={4} md={4} lg={3} xl={2}>
              <TextField
                id="outlined-basic"
                label="Select Date"
                variant="outlined"
                onFocus={() => setOpen(true)}
                fullWidth={true}
                autoComplete="off"
                value={`${format(dateRange.startDate, "MM/dd/yyyy")} - ${format(
                  dateRange.endDate,
                  "MM/dd/yyyy"
                )}`}
              />
              <DateRangePicker
                open={open}
                toggle={toggle}
                onChange={(range) => dateRangeHandler(range)}
              />
            </Grid>

            {/* <Grid item xs={8} sm={4} lg={2} xl={2}>
              <Input
                style={{ marginTop: "22px" }}
                placeholder="User name"
                inputProps={{ "aria-label": "user name" }}
                onChange={(e) => setuserName(e.target.value)}
              />
            </Grid> */}
            <Grid item xs={1} xl={1}>
              <Button
                style={{ marginTop: "22px" }}
                variant="contained"
                color="primary"
                onClick={() => {
                  dataFilter();
                }}
              >
                Search
              </Button>
            </Grid>
            {/* <Grid item xs={8} md={5} lg={3} xl={3}>
							<Input style ={{marginTop: "22px"}} placeholder="User name" inputProps={{ 'aria-label': 'user name' }} onChange={e => setuserName(e.target.value)}/>
							<Button style ={{marginTop: "22px"}} variant="contained" color="primary"  onClick={() => {dataFilter()}}>Search</Button>
						</Grid> */}
          </Grid>
        </div>

        {!dataLoaded ? (
          <Preloader />
        ) : (
          <MuiThemeProvider theme={getMuiTheme()}>
		            <div style={tableStyle}>
              <div style={cellStyle}>Turn Over Date</div>
              <div style={cellStyle}>{turnoverdate}</div>
              <div style={cellStyle}>Pacakge Sales Total</div>
              <div style={cellStyle}>{numeral(packageDirect).format("0,0.00") ?? 0.00}</div>
            </div>
	    


            <MUIDataTable
              // title={
              // 	<div>
              // 
              // 		<div className="table-title">

              // 		</div>
              // 	</div>
              // }
              data={posts  && posts.length ? posts : []}
              columns={columns}
              options={options}
            />
	    	    <Button
  variant="outlined" // Outlined variant for white background
  style={{
	marginTop:20,
	marginBottom:20,
    textAlign: "right",
    padding: "10px 20px",
    backgroundColor: "white",
    borderRadius: "5px",
    border: "1px solid #ccc",
    boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)"
  }}
>
  <strong>Total Amount: {numeral(pkgTotal).format("0,0.00")}</strong>
</Button>
          </MuiThemeProvider>
        )}

        {!dataLoaded ? (
          <Preloader />
        ) : (
          <>
            <div style={tableStyle}>
              <div style={cellStyle}>Turn Over Date</div>
              <div style={cellStyle}>{turnoverdate}</div>
              <div style={cellStyle}>Direct Sales Total</div>
              <div style={cellStyle}>{numeral(turnoverDirect).format("0,0.00")}</div>
            </div>
            <MuiThemeProvider theme={getMuiTheme()}>
              <MUIDataTable
                // title={
                // 	<div>
                // 
                // 		<div className="table-title">

                // 		</div>
                // 	</div>
                // }
                data={drSalesItem && drSalesItem.length ? drSalesItem : []}
                columns={columns}
                options={options}
              />
            </MuiThemeProvider>
	    <Button
  variant="outlined" // Outlined variant for white background
  style={{
	marginTop:20,
	marginBottom:20,
    textAlign: "right",
    padding: "10px 20px",
    backgroundColor: "white",
    borderRadius: "5px",
    border: "1px solid #ccc",
    boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)"
  }}
>
  <strong>Total Amount: {numeral(drTotal).format("0,0.00")}</strong>
</Button>
          </>
        )}
      </div>
    </div>
  );
};

export default CashierTurnOver;
